export default __webpack_public_path__ + "static/media/photovoltaicSmall.21662812.jpg";